import * as React from "react";

import { Body1, Spinner, Title1 } from "@fluentui/react-components";

import { useStyles } from "./styles";
import ProgressBar from "../../../../components/ProgressBar/ProgressBar";
import { useScanning } from "../../../../hooks/useScanning";
import { ScanningStatus } from "../../../../models/benchly.models";

const Scanning: React.FC = () => {
  const styles = useStyles();
  const { status, progress, statusMessage, foundCitations, errorMessage } = useScanning();

  const isLoading =
    status === ScanningStatus.Scanning ||
    status === ScanningStatus.ExactSearching ||
    status === ScanningStatus.Idle;

  const hasError = status === ScanningStatus.Error;
  const noCitationsFound = status === ScanningStatus.NoCitations;

  return (
    <div className={styles.container}>
      <Title1>Scanning</Title1>

      {hasError ? (
        <>
          <Body1 style={{ color: "red", fontWeight: 600, marginTop: 16 }}>
            {errorMessage || "Backend service is down, please try again later"}
          </Body1>
          <Body1 style={{ marginTop: 8 }}>Redirecting to home in some seconds...</Body1>
        </>
      ) : noCitationsFound ? (
        <>
          <Body1 style={{ fontWeight: 600, marginTop: 16 }}>No citations found in document</Body1>
          <Body1 style={{ marginTop: 8 }}>Redirecting to home in some seconds...</Body1>
        </>
      ) : (
        <>
          <Body1>
            {isLoading
              ? "Scanning your document for legal citations and references..."
              : "Scan complete! Analyzing citations..."}
          </Body1>

          <div className={styles.progressSection}>
            <Body1>
              Progress: {Math.round(progress * 100)}% - {statusMessage}
            </Body1>
            <ProgressBar value={progress} loading={isLoading} />
          </div>

          <Body1>Found {foundCitations} potential citations.</Body1>

          {isLoading && <Spinner size="tiny" />}
        </>
      )}
    </div>
  );
};

export default Scanning;
